import React from 'react'
import {
  Controller,
  Control,
  RegisterOptions,
  FieldError,
} from 'react-hook-form'
import { Select, MenuItem, InputLabel, FormControl } from '@material-ui/core'
import { SizeOptions } from 'TypeDefs/FormSongs'
import useStyles from './SelectSong.styles'
import { ReactHookFormRenderProp } from '../InputSong/InputSong'

type SelectSongProps = {
  name: string
  options: {
    value: string
    label: string
  }[]
  label?: string
  defaultValue?: string
  register?: () => void
  control?: Control
  rules?: RegisterOptions
  error?: FieldError
  required?: boolean
  size: SizeOptions
  subheader?: string
  titleWithTooltip?: string
  tooltipIndex?: number
  tooltipText?: string
  helperMessage?: string
  menuProps?: Record<string, unknown>
  autoFocus?: boolean
  onBlurHandler?: (
    e: React.SyntheticEvent,
    reactHookFormProps: ReactHookFormRenderProp
  ) => void
  /** Description of prop "onChangeHandler".
   *
   * If you are setting state or calling hooks that will cause re-render,
   * then re-consider because that defeats the purpose of react-hook-form
   */
  onChangeHandler?: (
    e: React.SyntheticEvent | any,
    reactHookFormProps: ReactHookFormRenderProp
  ) => void
}

const SelectSong = ({
  rules,
  control,
  options,
  name,
  label,
  defaultValue,
  error,
  required,
  subheader,
  helperMessage,
  onBlurHandler,
  onChangeHandler,
  menuProps,
  autoFocus,
}: SelectSongProps) => {
  const classes = useStyles()
  const getRequired = required ? 'This field is required' : ''

  return (
    <FormControl className={classes.formControl}>
      <InputLabel htmlFor={`${name}-select`} variant='outlined'>
        {label}{' '}
      </InputLabel>
      <Controller
        render={({ onChange, onBlur, value, ref }, inputState) => (
          <Select
            autoFocus={autoFocus}
            value={value}
            displayEmpty
            name={name}
            color='primary'
            variant='outlined'
            id={`${name}-select`}
            onChange={(e) => {
              onChange(e)
              if (onChangeHandler) {
                onChangeHandler(e, { value, inputState })
              }
            }}
            onBlur={(e) => {
              onBlur()
              if (onBlurHandler) {
                onBlurHandler(e, { value, inputState })
              }
            }}
            inputRef={ref}
            inputProps={{
              'data-testid': name,
            }}
            MenuProps={menuProps}
          >
            <MenuItem value='' disabled />
            {options.map((option) => (
              <MenuItem
                key={option.value}
                value={option.value}
                classes={{ selected: classes.selected }}
              >
                {option.label}
              </MenuItem>
            ))}
          </Select>
        )}
        id={`${name}-select`}
        name={name}
        rules={{ required: getRequired }}
        control={control}
        defaultValue=''
        error={!!error}
      />
    </FormControl>
  )
}

export default SelectSong
